import { styled } from '@mui/system';
import TextField from '@mui/material/TextField';
export const StyledForm = styled('form')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),
}));

export const StyledFormSectionContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

export const FormSection = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

export const StyledTextField = styled(TextField)(({ theme }) => ({
  // Define custom properties for label positioning
  '--label-translate-x': '14px',
  '--label-translate-y': '16px',
  '--label-shrink-y': '-9px',
  '--label-offset': '-7px',

  '& .MuiOutlinedInput-root': {
    borderRadius: '8px',
    '& fieldset': {
      borderColor: theme.colors.gray,
      borderWidth: '1px',
    },
    '&:hover fieldset': {
      borderColor: theme.colors.gray,
      borderWidth: '1px',
    },
    '&.Mui-focused fieldset': {
      borderColor: theme.colors.blue,
      borderWidth: '1px !important',
    },
    // Hide placeholder when input is focused
    '&.Mui-focused input::placeholder': {
      opacity: 0,
    },
  },

  // Label positioning and styling
  '& .MuiInputLabel-root': {
    ...theme.typography.bodyRegular,
    color: theme.colors.gray,
    transform: 'translate(var(--label-translate-x), var(--label-translate-y)) scale(1)',
    '&.Mui-focused': {
      color: theme.colors.blue,
    },
    '&.MuiInputLabel-shrink': {
      background: theme.colors.background,
      padding: '0 4px', // Minimal padding to prevent border overlap
      transform: 'translate(var(--label-translate-x), var(--label-shrink-y)) scale(0.75)',
    },
  },

  // Offset to align label with input border notch
  '& .MuiFormLabel-root': {
    marginLeft: 'var(--label-offset)',
  },

  // Input styling
  '& input': {
    ...theme.typography.bodyRegular,
  },
  '& input::placeholder': {
    ...theme.typography.bodyRegular,
    color: theme.colors.gray,
    opacity: 1,
  },

  // Chrome autocomplete overrides
  '& input:-webkit-autofill, & input:-webkit-autofill:hover, & input:-webkit-autofill:focus, & input:-webkit-autofill:active':
    {
      '-webkit-box-shadow': '0 0 0 30px transparent inset !important',
      '-webkit-text-fill-color': `${theme.colors.white} !important`,
      transition: 'background-color 5000s ease-in-out 0s',
    },
}));

export const StyledButtonContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
}));
